import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen animated-background" style={{ paddingTop: '80px' }}>
      <div className="max-w-4xl mx-auto py-24" style={{ padding: '120px 7.6923% 100px' }}>
        <h1 className="display-large mb-8" style={{ color: 'var(--text-primary)' }}>
          Privacy Policy
        </h1>
        <p className="body-medium mb-8" style={{ color: 'var(--text-muted)' }}>
          Last Updated: November 02, 2025
        </p>
        
        <div className="space-y-6">
          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              1. INFORMATION WE COLLECT
            </h2>
            <p className="body-medium mb-3" style={{ color: 'var(--text-secondary)' }}>
              We gather information you voluntarily share when you:
            </p>
            <ul className="space-y-2" style={{ paddingLeft: '20px' }}>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Establish an account with our platform
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Engage with our comprehensive services
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Reach out for dedicated support assistance
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Subscribe to our exclusive newsletter
              </li>
            </ul>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              2. HOW WE UTILIZE YOUR INFORMATION
            </h2>
            <p className="body-medium mb-3" style={{ color: 'var(--text-secondary)' }}>
              We leverage collected data to:
            </p>
            <ul className="space-y-2" style={{ paddingLeft: '20px' }}>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Deliver, maintain, and continuously enhance our services
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Process transactions with precision and dispatch related communications
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Distribute technical updates and dedicated support messages
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Address your inquiries and valuable feedback
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Share insights about premium products, services, and exclusive promotions
              </li>
            </ul>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              3. INFORMATION SHARING
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We steadfastly refrain from selling, trading, or transferring your personal information to external parties without your explicit consent, except as delineated in this policy.
            </p>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              4. DATA SECURITY
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We deploy robust security protocols to safeguard your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              5. COOKIES AND TRACKING
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We employ cookies and analogous tracking technologies to elevate your browsing experience on our digital platform.
            </p>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              6. YOUR RIGHTS
            </h2>
            <p className="body-medium mb-3" style={{ color: 'var(--text-secondary)' }}>
              You possess the right to:
            </p>
            <ul className="space-y-2" style={{ paddingLeft: '20px' }}>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Access your comprehensive personal information
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Rectify any inaccurate information
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Request deletion of your personal information
              </li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                • Object to specific information processing
              </li>
            </ul>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              7. DATA RETENTION
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We preserve your personal information for the duration necessary to deliver our services and fulfill the objectives outlined in this comprehensive policy.
            </p>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              8. CHILDREN'S PRIVACY
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Our services are exclusively designed for individuals aged 13 and above. We consciously abstain from knowingly collecting personal information from children under 13.
            </p>
          </div>

          <div>
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              9. POLICY MODIFICATIONS
            </h2>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We may periodically update this privacy policy. Significant changes will be communicated through prominent website notifications or direct email correspondence.
            </p>
          </div>

          <div className="pt-8">
            <h2 className="heading-2 mb-3" style={{ color: 'var(--brand-primary)' }}>
              10. CONTACT US
            </h2>
            <p className="body-medium mb-4" style={{ color: 'var(--text-secondary)' }}>
              For questions regarding this Privacy Policy, please contact:
            </p>
            <div className="space-y-2">
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                <strong>American Prime LLC</strong>
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Email: info@americanprimellc.com
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Phone: +1 (203) 589-9774
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Service Area: United States / North America
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
